document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.featured-products-swiper-v2').forEach((sliderEl) => {

    const arrowPrev = sliderEl.querySelector('.featured-swiper-nav2.swiper-button-prev');
    const arrowNext = sliderEl.querySelector('.featured-swiper-nav2.swiper-button-next');

    new Swiper(sliderEl, {
        slidesPerView: 2,
        spaceBetween: 20,
        loop: true,
        navigation: {
        nextEl: arrowNext,
        prevEl: arrowPrev
        },
        breakpoints: {
            768: {
                slidesPerView: 2.5
            },
            1024: {
                slidesPerView: 5
            }
        }
    });

    // const swiperEl = document.querySelector('.featured-products-swiper-v2');
    // const arrowPrev = document.querySelector('.featured-products-swiper-v2 .swiper-button-prev');
    // const arrowNext = document.querySelector('.featured-products-swiper-v2 .swiper-button-next');

    // if (arrowPrev && arrowNext) {
    //     const updateArrowPosition = () => {
    //     const height = sliderEl.offsetHeight;
    //     arrowPrev.style.marginTop = `${height / 2 - 24}px`; // 24 = half arrow height
    //     arrowNext.style.marginTop = `${height / 2 - 24}px`;
    //     };

    //     // Set once after DOM load
    //     updateArrowPosition();

    //     // Also set after all images load (since height may change)
    //     window.addEventListener('load', updateArrowPosition);

    //     // Optional: recalculate on window resize
    //     window.addEventListener('resize', updateArrowPosition);
    // }
    });
});